import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppStateService } from 'src/app/services/app-state.service';
import { DataService } from 'src/app/services/data.service';
import { WistaAMSTypes } from 'src/app/wista-ams-types';
import { Location } from '../../../classes';

@Component({
  selector: 'app-select-location',
  templateUrl: './select-location.component.html',
  styleUrls: ['./select-location.component.css']
})
export class SelectLocationComponent implements OnChanges, OnInit {

  @Input() editMode: boolean = true;
  @Input() label: string = "Standort";
  @Input() placeholder: string;
  @Input() showCurrentValues: boolean = false;
  @Input() set presetted(value: number) {
    this._presetted = value;
    this.dataService.resolve(WistaAMSTypes.Location, value, () => {
      this.setLocation(value);
    }, true);
  }

  @Output() valueChanged: EventEmitter<number> = new EventEmitter();

  get location(): Location {
    return this._location;
  }
  private _location: Location;

  _presetted: number;
  get presetted(): number {
    return this._presetted;
  }

  locations = new BehaviorSubject<Location[]>([]);

  containsChanges: boolean = false;
  formGroup: FormGroup;

  subscriptions: Subscription[] = [];

  /**
   * the constructor creates a new instance of the component
   * @param _formBuilder 
   * @param dataService 
   */
  constructor(
    private _formBuilder: FormBuilder,
    public dataService: DataService,
    private _appState: AppStateService
  ) {
    this.formGroup = this._formBuilder.group({
      "location": [null, Validators.required],
      "filter": null
    });
    if (this._appState.objectCache['currentIssue']) {
      	
    }
    this.subscriptions.push(...[
      this.locations.subscribe((value) => this.setLocation(this.locationControl.value)),
      this
        .filterControl
        .valueChanges
        .pipe(
          debounceTime(1000)
        )
        .subscribe(
          (value) => {
            this.dataService.searchLocations(value);
          }
        )
    ]);
  }
  /**
   * the method returns a string representation of the location with the passed identifier
   */
  display(id) {
    if (!id) return "";
    let index = this.dataService.locations.findIndex(x => x.locationid === id);
    if (index == -1) return "";
    var preview = "";
    if (this.dataService.locations[index].address) {
      if (this.dataService.locations[index].address.addressstreet) preview += this.dataService.locations[index].address.addressstreet;
      if (this.dataService.locations[index].address.addresshousenumber) preview += ` ${this.dataService.locations[index].address.addresshousenumber}`;
      if (this.dataService.locations[index].address.addresszipcode) preview += `, ${this.dataService.locations[index].address.addresszipcode}`;
      if (this.dataService.locations[index].address.addresscity) preview += ` ${this.dataService.locations[index].address.addresscity}`;
    }
    return preview;
  }
  /**
   * the method checks whether the passed location matches the setted filter
   */
  matchesFilter(location: Location): boolean {
    var i;
    if (!location) return false;
    if (!this.filterControl.value || typeof (this.filterControl.value) !== "string" || this.filterControl.value.length == 0) return true;
    let filter = (this.filterControl.value as string).toLowerCase();
    if (location.address && location.address.addressstreet) {
      i = location
        .address
        .addressstreet
        .toLowerCase()
        .indexOf(filter);
      if (i > -1) return true;
    }
    return false;
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if(simpleChanges['editMode']) this.filterControl[this.editMode? 'enable': 'disable']();
  }
  /**
   * the method is called on component disposition
   */
  ngOnDestroy(): void {
    for (let sub of this.subscriptions) sub.unsubscribe();
    this.subscriptions = [];
  }
  /**
   * the method is called on component initalization
   */
  ngOnInit(): void {
    this.filterControl[this.editMode? 'enable': 'disable']();
  }
  /**
   * the method resets the contactperson
   */
  resetValue() {
    if (this.presetted != this.locationControl.value) this.containsChanges = true;
    else this.containsChanges = false;
  }
  /**
   * the method sets a location
   * @param identifier
   */
  setLocation(identifier: number) {
    let changed = identifier !== this.locationControl.value;
    if (identifier) {
      this.locationControl.setValue(identifier);
      this.filterControl.setValue(identifier);
    } else {
      this.locationControl.setValue(null);
      this.filterControl.setValue(null);
    }
    changed && this.valueChanged.emit(this.locationControl.value);
  }
  // CONTROLS
  get locationControl(): AbstractControl {
    return this.formGroup.controls["location"];
  }
  get filterControl(): AbstractControl {
    return this.formGroup.controls["filter"];
  }

}
